import { Component, NgZone, OnInit } from '@angular/core';
import { LocalSystemService } from '../local-system.service';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-fuji-service-presale',
  templateUrl: './fuji-service-presale.component.html',
  styleUrls: ['./fuji-service-presale.component.css']
})
export class FujiServicePresaleComponent implements OnInit {
  protocols:any = [];
  currentPage:any = 1;
  total_pages = 0;
  total_pages_array = [];
  modal:any = { open:false, cntx:"", obj:{} }

  search_by = 'client_name';
  search:any = '';
  searched:any = false;

  timeoutSerialInner:any;

  constructor(public ngZone:NgZone, public system:LocalSystemService, public http:HttpClient) { }

  ngOnInit(): void {
    this.getProtocols();
  }

  openModal(cntx, obj) { 
    this.modal = { 
      open:true, 'cntx':cntx, 'obj':obj }
      if(cntx == 'export-service') {
        obj.start_date = new Date();
        obj.end_date = new Date();
        obj.current_start_date = new Date();
        obj.current_end_date = new Date();
        obj.dates = [];
      } 
  }
  closeModal() { this.modal.open = false; }

  getProtocols() {
    this.openModal('loading-fuji-services', {});
    let url = "api/service.php?action=get_fuji_service_presale&page=" + this.currentPage + "&search_by=" + this.search_by;
    // if(this.brand != 'all') { url += "&by_brand=" + this.brand; }
    // if(this.timeline != '0') { url += "&by_date=" + this.timeline; }
    // if(this.serial != '') { url += "&serial=" + this.serial; }
    this.http.get(url).subscribe((data) => {
      if(data['logged']) {

        // if(this.search_by == 'serial' && this.serial != '') { this.searched = true; }
        this.protocols = data['protocols'];
        this.total_pages = data['total_pages'];
        this.total_pages_array = [];
        for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
        this.ngZone.run(()=> {});
        setTimeout(()=>{
          this.closeModal();
        }, 500);
      } else {
        this.system.Logout();
      }
    });
  }

  searchProtocolDrones() {
    this.currentPage = 1;
    this.searched = true;
    this.openModal('loading-drone-services', {});
    // this.http.get("api/service.php?action=search_drone_service&page=" + this.currentPage + "&search_type=" + this.search_by + "&search=" + this.search).subscribe((data) => {
    //   this.protocols = data['protocols'];
    //   this.total_pages = data['total_pages'];
    //   this.total_pages_array = [];
    //   for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
    //   this.closeModal();
    //   localStorage.setItem('drones_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_by, 'search':this.search }));
    // });
  }
  switchPageSearch() {
    this.openModal('loading-drone-services', {})
    // this.http.get("api/service.php?action=search_drone_service&page=" + this.currentPage + "&search_type=" + this.search_by + "&search=" + this.search).subscribe((data) => {
    //   this.protocols = data['protocols'];
    //   this.total_pages = data['total_pages'];
    //   this.total_pages_array = [];
    //   for(let i = 0; i < this.total_pages; i++) { this.total_pages_array.push(0); }
    //   this.closeModal();
    //   localStorage.setItem('drones_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_by, 'search':this.search }));
    // });
  }
  clearSearched() { 
    this.searched = false; 
    this.search_by = "client_name";
    this.search = "";
    this.currentPage = 1;
    localStorage.setItem('drones_search_obj', JSON.stringify({ 'page':this.currentPage, 'searched':this.searched, 'search_type':this.search_by, 'search':this.search }));
    this.getProtocols();
  }


  switchPage(page) {
    this.currentPage = page;
    if(!this.searched) { this.getProtocols(); }
    else { this.switchPageSearch(); }
  }

 
  promptDelete(protocol_id) { this.openModal('remove-protocol', { 'protocol_id':protocol_id }); }
  deleteProtocol(protocol_id) {
    this.http.get("api/service.php?action=remove_fuji_service_presale&protocol_id=" + protocol_id).subscribe((data) => {
      this.closeModal();
      this.getProtocols();
    });
  }


  printFujiProtocol(protocol) {
    window.location.href = 'http://warranty.tempex.bg/print_fuji_protocol.php?protocol_id=' + protocol.service_num + "&presale=true";
  }

  ExportServices() {
    this.system.getFujiServicesPresaleForExport(this.returnDateFormatedForDatabase(this.modal.obj.start_date), this.returnDateFormatedForDatabase(this.modal.obj.end_date), this);
  }

  CompleteExportServices(data) {
      let exportable_array = [];
      let protocols = data['protocols'];
      for(var di = 0; di < protocols.length; di++) {
        for(var si = 0; si < protocols[di]['serial_list_arr'].length; si++) {
          exportable_array.push({ 'Име на дилър':protocols[di]['dealer_name'], 'Дата на замяна':protocols[di]['date_of_return'], 'Дефектирало вън.тяло сериен':protocols[di]['serial_list_arr'][si], 'Подеменено вън.тяло сериен':protocols[di]['replaced_serials'][si] });
        }
      }
      var worksheet = XLSX.utils.json_to_sheet(exportable_array);
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    
        /* save to file */  
        let dt = new Date();
        XLSX.writeFile(wb, "Протоколи за подмяна предпродажно"+ this.returnDateFormated(this.modal.obj.start_date) +"-"+ this.returnDateFormated(this.modal.obj.end_date) +".xlsx");
        this.closeModal();
      console.log(data);
    }


  // DATEPICKERS

  openDateEndPicker() {
    this.timeoutSerialInner = setTimeout(()=>{      
      this.modal.obj.end_picker = true; 
      this.modal.obj.current_end_date = new Date(this.modal.obj.end_date);
      this.Formulate(this.modal.obj.current_end_date);
    }, 50);
  }

  selectStartDate(dt){
    this.modal.obj.start_date.setYear(this.modal.obj.current_start_date.getFullYear());
    this.modal.obj.start_date.setDate(dt.date);
    this.modal.obj.start_date.setMonth(dt.month);
    this.modal.obj.start_picker = false;
  }

  prevMonth(dt) { dt.setMonth(dt.getMonth() - 1); this.Formulate(dt); }
  nextMonth(dt) { dt.setMonth(dt.getMonth() + 1); this.Formulate(dt); }

  openDateStartPicker() {
    this.timeoutSerialInner = setTimeout(()=>{      
      this.modal.obj.start_picker = true; 
      this.modal.obj.current_start_date = new Date(this.modal.obj.start_date);
      this.Formulate(this.modal.obj.current_start_date);
    }, 50);
  }

  selectEndDate(dt){
    this.modal.obj.end_date.setYear(this.modal.obj.current_end_date.getFullYear());
    this.modal.obj.end_date.setDate(dt.date);
    this.modal.obj.end_date.setMonth(dt.month);
    this.modal.obj.end_picker = false;
  }

  Formulate(dt) {
    this.modal.obj.dates = [];

    var firstDay = new Date(dt.getFullYear(), dt.getMonth(), 1);
    var lastDay = new Date(dt.getFullYear(), dt.getMonth() + 1, 0);
    let predate_num = 0;
    // GENERATE PREDATE

    for(let i = 0; i < 42 - lastDay.getDate(); i++) {
        let day_idx = i;
        let first_day = firstDay.getDay();
        if(first_day == 0) { first_day = 7; }
        if(day_idx < first_day - 1) {
            let negative_day = day_idx * -1;
            let date_reformed = new Date(dt.getFullYear(), dt.getMonth(), negative_day);
            this.modal.obj.dates.unshift({ "date": date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false})
            predate_num += 1;
        }
    }
    for(let i = 0; i < lastDay.getDate(); i++) {
        let day_id = i + 1;
        this.modal.obj.dates.push({ "date":day_id, "month":dt.getMonth(), "active":true });
    }
    for(let i = 0; i < 42 - lastDay.getDate() - predate_num; i++) {
        let date_reformed = new Date(dt.getFullYear(), dt.getMonth() + 2, i + 1);
        this.modal.obj.dates.push({ "date":date_reformed.getDate(), "month":date_reformed.getMonth(), "active":false });
    }
  }

  returnYear(dt) { return dt.getFullYear(); }
  returnMonth(dt) { return dt.getMonth() + 1; }
  returnMonthName(month) {
    if(month == 1) { return "Януари"; }
    else if(month == 2) { return "Февруари"; }
    else if(month == 3) { return "Март"; }
    else if(month == 4) { return "Април"; }
    else if(month == 5) { return "Май"; }
    else if(month == 6) { return "Юни"; }
    else if(month == 7) { return "Юли"; }
    else if(month == 8) { return "Август"; }
    else if(month == 9) { return "Септември"; }
    else if(month == 10) { return "Октомври"; }
    else if(month == 11) { return "Ноември"; }
    else if(month == 12) { return "Декември"; }
    else { return ""; }
  }
  returnDate(dt) { return dt.getDate();  }
  returnDateFormated(dt){
    return this.returnPadZero(dt.getDate(), 2) + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + dt.getFullYear();
  }
  
  returnDateFormatedForDatabase(dt){
    return dt.getFullYear() + "-" + this.returnPadZero(dt.getMonth()+ 1, 2) + "-" + this.returnPadZero(dt.getDate(), 2);
  }

  returnPadZero(number, length) {
    var my_string = '' + number;
    while (my_string.length < length) {
        my_string = '0' + my_string;
    }
    return my_string;
  }

}
